(ns frontend.view.task.webentry-resolution.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :webentry-task-resolution]))
(defonce temp-state (r/cursor state [:temp-values]))

(defonce timeout-state (atom {}))
